import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const ConfigContext = createContext({ google_maps_key: "", email_enabled: false, app_url: "" });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ google_maps_key: "", email_enabled: false, app_url: "" });
  const { user } = useAuth();

  useEffect(() => {
    api.get("/public/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  // Apply per-user branding (white-label)
  useEffect(() => {
    if (user?.brand_color) {
      document.documentElement.style.setProperty("--accent-copper", user.brand_color);
    } else {
      document.documentElement.style.setProperty("--accent-copper", "#d4a574");
    }
    if (user?.app_title_override) {
      document.title = user.app_title_override;
    } else {
      document.title = "The Close Out — Distress Intelligence";
    }
  }, [user]);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
